import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Preloader } from '@/components/Preloader';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { EMPTY_DASH } from '@/helpers/constants';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { useGetStreakActivityInfinity } from '@/query/queries/streak/useGetStreakActivityInfinity';
import { StreakActivityDetailModal } from '../modals/StreakActivityDetailModal';
import { EmptyContent } from '../components/EmptyContent';
import { StreakStatus } from '../components/StreakStatus';
import IconArrow from './icon_arrow.svg';
import s from './index.module.scss';

export const ActivityMobile = () => {
  const { openSingleModal, setData } = useModal();
  const { t } = useTranslation('streak');
  const { data, fetchNextPage, hasNextPage, isLoading } =
    useGetStreakActivityInfinity();

  const isEmpty = !data?.pages[0]?.total_count;

  const fetchData = () => {
    hasNextPage && fetchNextPage();
  };

  const openDetail = async streakData => {
    await setData(streakData);
    openSingleModal(MODAL_IDS.streak_activity_detail);
  };

  return isLoading ? (
    <Preloader className={s.preloader} />
  ) : isEmpty ? (
    <div className={s.empty}>
      <EmptyContent />
    </div>
  ) : (
    <>
      <div className={classnames(s.header, 'f-tiny-accent')}>
        <div>{t('activity_mobile.topped_up_withdrawn')}</div>
        <div>{t('activity_mobile.net_cash_flow_status')}</div>
      </div>
      <InfiniteScroll
        dataLength={data?.pages.length || 0}
        next={fetchData}
        hasMore={hasNextPage}
        loader={<Preloader style={{ height: '80px' }} />}
      >
        {data?.pages.map(page =>
          Object.keys(page.grouped)
            .reverse()
            .map(year => (
              <div key={year}>
                <div
                  className={classnames(
                    s.year,
                    year === new Date().getFullYear().toString() &&
                      s.year_hidden,
                    'f-article-accent',
                  )}
                >
                  {year}
                </div>
                {page.grouped[year].map((item, index) => (
                  <div
                    key={item.round_date + index}
                    className={s.card}
                    onClick={() => openDetail(item)}
                  >
                    <div className={s.left}>
                      <div className="f-body-accent">
                        {prettyDate(item.round_date, 'MMMM')}
                      </div>
                      <div className={s.stats}>
                        <div className={s.values}>
                          <img
                            src={IconArrow}
                            alt="arrow"
                            width={8}
                            height={16}
                          />
                          <span className="f-small-regular">
                            {prettyFloatMoney(item.topped_up, {
                              decimalPlaces: 2,
                            })}
                          </span>
                        </div>
                        <div className={s.break} />
                        <div className={s.values}>
                          <img
                            src={IconArrow}
                            style={{ transform: `rotate(180deg)` }}
                            alt="arrow"
                            width={8}
                            height={16}
                          />
                          <span className="f-small-regular">
                            {prettyFloatMoney(item.withdrawn, {
                              decimalPlaces: 2,
                            })}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className={s.right}>
                      <div className="f-body-regular">
                        {Number(item.net_cash_flow_bonus)
                          ? prettyFloatMoney(item.net_cash_flow_bonus, {
                              decimalPlaces: 2,
                            })
                          : EMPTY_DASH}
                      </div>
                      <StreakStatus status={item.round_status} />
                    </div>
                  </div>
                ))}
              </div>
            )),
        )}
      </InfiniteScroll>
      <StreakActivityDetailModal />
    </>
  );
};
